var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"DgButton shadow shadow--button noSelect",class:_vm.elmClasses,attrs:{"href":_vm.href,"target":_vm.target}},[_c('span',{staticClass:"DgButton__inner"},[(_vm.type)?_c('MhIcon',{staticClass:"DgButton__icon",attrs:{"type":_vm.type}}):_vm._e(),_c('span',{staticClass:"DgButton__text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }